module.exports = __webpack_public_path__ + "img/reject.ae32f5ba.png";